import { FC } from "react";
import { ResponsiveBar } from "@nivo/bar";

type BarAVGCoachResponseProps = {
  data: {
    fast: number;
    moderate: number;
    slow: number;
    verySlow: number;
  };
};

export const BarAVGCoachResponse: FC<BarAVGCoachResponseProps> = ({ data }) => {
  const chartData = [
    {
      category: "Very Slow",
      value: data.verySlow,
      color: "#F44336",
    },
    {
      category: "Slow",
      value: data.slow,
      color: "#FF9800",
    },
    {
      category: "Moderate",
      value: data.moderate,
      color: "#FFC107",
    },
    {
      category: "Fast",
      value: data.fast,
      color: "#4CAF50",
    },
  ];

  return (
    <div style={{ height: "300px", width: "100%" }}>
      <ResponsiveBar
        data={chartData}
        keys={["value"]}
        indexBy="category"
        layout="horizontal"
        margin={{ top: 20, right: 20, bottom: 40, left: 70 }}
        padding={0.3}
        valueScale={{ type: "linear" }}
        indexScale={{ type: "band", round: true }}
        colors={({ data }) => data.color}
        borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
        tooltip={({ data }) => (
          <div
            style={{
              padding: "8px",
              background: "white",
              borderRadius: "4px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            <strong>{data.category}:</strong> {data.value}
          </div>
        )}
        animate={true}
      />
    </div>
  );
};
